var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModalSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0C41.7154 0 31.6617 3.04975 23.1104 8.76358C14.559 14.4774 7.89404 22.5987 3.95829 32.1005C0.0225306 41.6022 -1.00724 52.0577 0.999189 62.1447C3.00562 72.2317 7.95814 81.4972 15.2305 88.7695C22.5028 96.0419 31.7683 100.994 41.8553 103.001C51.9423 105.007 62.3978 103.977 71.8995 100.042C81.4013 96.106 89.5226 89.441 95.2364 80.8896C100.95 72.3383 104 62.2846 104 52C104 38.2087 98.5214 24.9823 88.7696 15.2304C79.0177 5.47856 65.7913 0 52 0V0ZM52 97.5C43.001 97.5 34.204 94.8315 26.7216 89.8318C19.2391 84.8322 13.4073 77.7261 9.9635 69.4121C6.51972 61.098 5.61866 51.9495 7.37429 43.1234C9.12992 34.2972 13.4634 26.1899 19.8267 19.8266C26.1899 13.4633 34.2973 9.1299 43.1234 7.37427C51.9495 5.61864 61.0981 6.51969 69.4121 9.96348C77.7261 13.4073 84.8323 19.2391 89.8319 26.7215C94.8315 34.204 97.5 43.0009 97.5 52C97.5 64.0673 92.7063 75.6404 84.1734 84.1733C75.6405 92.7062 64.0674 97.5 52 97.5Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8394 36.855L43.9719 66.7225L30.1594 52.9425C29.5377 52.41 28.7379 52.1318 27.92 52.1634C27.102 52.195 26.3261 52.5341 25.7473 53.1129C25.1685 53.6917 24.8294 54.4676 24.7978 55.2855C24.7662 56.1035 25.0445 56.9032 25.5769 57.525L39.3569 71.305C39.9606 71.9093 40.6774 72.3887 41.4665 72.7158C42.2556 73.043 43.1014 73.2113 43.9556 73.2113C44.8098 73.2113 45.6557 73.043 46.4448 72.7158C47.2338 72.3887 47.9507 71.9093 48.5544 71.305L78.4219 41.4375C78.9543 40.8157 79.2325 40.016 79.2009 39.198C79.1693 38.3801 78.8303 37.6042 78.2515 37.0254C77.6727 36.4466 76.8968 36.1075 76.0788 36.0759C75.2609 36.0443 74.4611 36.3225 73.8394 36.855Z",
    fill: "#00CC99"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSuccess);
export default __webpack_public_path__ + "static/media/modal__success.351a7884.svg";
export { ForwardRef as ReactComponent };